import Vue from 'vue';
import Vuex from 'vuex';

import universities from './modules/universities';
import forms from './modules/forms';

import * as actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
	actions,
	modules: {
		universities,
		forms
	}
});
